import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, Select, Radio, Input, Button, Spin } from 'antd';
import { addClient, setIsIcSelect, setIsClient, getPrimaryTabsList, getCategoriesList } from '../../../redux/actions/Client/ClientActions';
import { getConfigList } from '../../../redux/actions/IC/ICActions';
import ClientFormWrapper from './ClientForm.style';

const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class ClientForm extends React.Component {

  constructor() {
    super();
    this.state = {
      categories_list: []
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDesignationChange = this.handleDesignationChange.bind(this);
    this.handlePrimaryTabsChange = this.handlePrimaryTabsChange.bind(this);
    this.handleAccessCategoriesChange = this.handleAccessCategoriesChange.bind(this);
  }

  componentDidMount() {
    this.props.getConfigList();
    this.props.getPrimaryTabsList();
    this.props.getCategoriesList();
    if (Object.keys(this.props.CLIENTSREDUCER.ic_box_user.user_to_update).length > 0) {
      if (this.props.CLIENTSREDUCER.ic_box_user.user_to_update.tabs.includes("Visualize") || this.props.CLIENTSREDUCER.ic_box_user.user_to_update.tabs.includes("DataSheet")) {
        this.props.setIsIcSelect(true);
      }
      else {
        this.props.setIsIcSelect(false);
      }

      if (this.props.CLIENTSREDUCER.ic_box_user.user_to_update.designation === "CLIENT") {
        this.props.setIsClient(true);
      }
      else {
        this.props.setIsClient(false);
      }
      if (this.props.CLIENTSREDUCER.ic_box_user.user_to_update.access_categories && this.props.CLIENTSREDUCER.ic_box_user.user_to_update.access_categories.length) {
        this.setState({
          ...this.state,
          categories_list: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.access_categories
        })
      }
    }
  }

  handleSubmit = (e) => {
    //ADDED categories field
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        if (values.expiry_time > 0) {
          values.expiry_time = values.expiry_time + ' hour';
        }
        else {
          values.expiry_time = 'none';
        }
        if (!values['IC'] || !this.props.CLIENTSREDUCER.is_ic_select) {
          delete values['IC'];
        }

        let formData = { ...values }
        formData['access_categories'] = this.state.categories_list
        this.props.addClient(formData, this.props.from);
      }
      else {
        console.log(err);
      }
    });
  }

  handleDesignationChange(value) {
    if (value === 'CLIENT') {
      this.props.setIsClient(true);
    }
    else {
      this.props.setIsClient(false);
    }
  }

  handlePrimaryTabsChange(value) {
    if (!value) {
      value = [];
    }

    if (value.includes("Visualize") || value.includes("DataSheet")) {
      this.props.setIsIcSelect(true);
    }
    else if (value.length === 0) {
      this.props.setIsIcSelect(false);
    }
    else {
      this.props.setIsIcSelect(false);
    }
  }

  handleAccessCategoriesChange(value) {
    let categoriesArray = []
    this.props.CLIENTSREDUCER.access_categories.map(category => {
      value.map(title => {
        if (category.title == title) {
          categoriesArray.push(category)
        }
      })
    })
    this.setState({
      categories_list: categoriesArray

    })
  }

  render() {

    const { getFieldDecorator } = this.props.form;

    const designation_options = this.props.LOGINREDUCER.USER.role === 'ADMIN'
      ?
      [<Option key={1} value="DEMO">DEMO</Option>,
      <Option key={2} value="CLIENT">CLIENT</Option>]
      :
      [<Option value="DEMO">DEMO</Option>]

    const ic_list = this.props.ICREDUCER.configList.map((ic, i) => <Option key={i} value={ic.ic_code}>{ic.name}</Option>);
    const primary_tabs_list = this.props.CLIENTSREDUCER.primary_tabs_list.map((tab, i) => <Option key={i} value={tab.name}>{tab.name}</Option>);
    const access_categories_list = this.props.CLIENTSREDUCER.access_categories.map((category, i) => <Option key={i} value={category.title}>{category.title}</Option>)
    return (
      <ClientFormWrapper>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <FormItem
                label="Name"
              >
                {getFieldDecorator('name', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.name,
                  rules: [
                    { required: true, message: 'Please enter Client name!' },
                  ],
                })(
                  <Input placeholder="Enter Client Name" />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Email"
              >
                {getFieldDecorator('email', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.email,
                  rules: [
                    { required: true, message: `Please enter Client's email id!` },
                  ],
                })(
                  <Input type="email" placeholder="Enter Client Email ID" />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <FormItem
                label="Username"
              >
                {getFieldDecorator('username', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.username,
                  rules: [
                    { required: this.props.from === 'add' ? true : false, message: `Please enter Client's username for the platform!` },
                  ],
                })(
                  <Input disabled={this.props.from === 'update' ? true : false} placeholder="Enter Client Username" />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Password"
              >
                {getFieldDecorator('password', {
                  rules: [
                    { required: this.props.from === 'add' ? true : false, message: `Please enter Client's password for the platform!` },
                  ],
                })(
                  <Input disabled={this.props.from === 'update' ? true : false} type="password" placeholder="Enter Client Password" />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={6}>
              <FormItem
                label="Designation"
              >
                {getFieldDecorator('designation', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.designation,
                  rules: [
                    { required: true, message: `Select designation for Client's Account!` },
                  ],
                })(
                  <Select onChange={this.handleDesignationChange} placeholder="Select a valid designation for Client's Account">
                    {designation_options}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Expiry Time"
              >
                {getFieldDecorator('expiry_time', {
                  initialValue: 0,
                  rules: [
                    { required: true, message: `Please enter a valid expiry time!` }
                  ],
                })(
                  <Input type="number" min={0} addonAfter="hours" placeholder="Enter Expiry Time for Client's Account" />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Primary Tabs"
              >
                {getFieldDecorator('tabs', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.tabs,
                  rules: [
                    { required: true, message: `Please select a valid set of tabs for Client's Account!` },
                  ],
                })(
                  <Select mode='multiple' onChange={this.handlePrimaryTabsChange} placeholder="Select primary tabs for Client's Account">
                    {primary_tabs_list}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={6}>
              <FormItem
                label="Download Permissions"
              >
                {getFieldDecorator('download_permission', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.download_permission,
                  rules: [
                    { required: true, message: `Please select download permissions for Client's Account!` },
                  ],
                })(
                  <RadioGroup>
                    <RadioButton value={true}>Yes</RadioButton>
                    <RadioButton value={false}>No</RadioButton>
                  </RadioGroup>
                )}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Company"
              >
                {getFieldDecorator('company', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.company,
                  rules: [
                    { required: true, message: `Please enter a valid company name!` },
                  ],
                })(
                  <Input placeholder="Enter Client Company" />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="IC"
              >
                {getFieldDecorator('IC', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.IC,
                  rules: [
                    { required: this.props.CLIENTSREDUCER.is_ic_select, message: `Please select a valid set of ICs for Client's Account!` },
                  ],
                })(
                  <Select notFoundContent={!this.props.configList ? <Spin size="small" /> : null} disabled={!this.props.CLIENTSREDUCER.is_ic_select} mode='multiple' placeholder="Select set of ICs for Client's Account">
                    {ic_list}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <FormItem
                label="Categories"
              >
                {getFieldDecorator('access_categories', {
                  initialValue: this.props.CLIENTSREDUCER.ic_box_user.user_to_update.access_categories && this.props.CLIENTSREDUCER.ic_box_user.user_to_update.access_categories.length ? this.props.CLIENTSREDUCER.ic_box_user.user_to_update.access_categories.map(category => category.title) : [],
                  rules: [
                    { required: true, message: `Please select a valid set of categories for Client's Account!` },
                  ],
                })(
                  <Select mode='multiple' onChange={this.handleAccessCategoriesChange} placeholder="Select categories for Client's Account">
                    {access_categories_list}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>
          <FormItem
          >
            <Button type="primary" loading={this.props.CLIENTSREDUCER.addingClientStatus} htmlType="submit">Submit</Button>
          </FormItem>

        </Form>

      </ClientFormWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  addClient,
  setIsClient,
  setIsIcSelect,
  getConfigList,
  getPrimaryTabsList,
  getCategoriesList
};

const Client = Form.create()(ClientForm);

export default connect(mapStateToProps, mapDispatchToProps)(Client);


// WEBPACK FOOTER //
// ./src/components/Client/Form/Form.js